import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {}
}));

const Breadcrumbs = props => {
  const { className, ...rest } = props;

  const breadcrumbs = props.breadcrumbs || [];
  const classes = useStyles();

  const LinkAtivo = (item, i) => (
    <span key={`bc-${i}`}>
      {" "}
      &#9658;{" "}
      <span
        key={`bci-${i}`}
        onClick={() => props.history.push(item.link)}
        style={{ textDecoration: "underline", cursor: "pointer" }}
      >
        {item.title}
      </span>
    </span>
  );

  const LinkInativo = (item, i) => (
    <span key={`bc-${i}`}> &#9658; {item.title}</span>
  );

  let last = breadcrumbs.length - 1;

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Typography component="h2" gutterBottom variant="overline">
        {breadcrumbs.map((item, i) => (
          <span key={`b-${i}`}>
            {i !== last && LinkAtivo(item, i)}
            {i === last && LinkInativo(item, i)}
          </span>
        ))}
      </Typography>
    </div>
  );
};

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.array,
  history: PropTypes.any
};

export default Breadcrumbs;
